import { render, staticRenderFns } from "./invitationOrder.vue?vue&type=template&id=4500f33a&scoped=true&"
import script from "./invitationOrder.vue?vue&type=script&lang=js&"
export * from "./invitationOrder.vue?vue&type=script&lang=js&"
import style0 from "./invitationOrder.vue?vue&type=style&index=0&id=4500f33a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4500f33a",
  null
  
)

export default component.exports